import script from "./menuBurger.vue?vue&type=script&setup=true&lang=ts"
export * from "./menuBurger.vue?vue&type=script&setup=true&lang=ts"

import "./menuBurger.vue?vue&type=style&index=0&id=6944dfe7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6944dfe7"]])

export default __exports__